import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";


const DoubleTheApples = () => {
  const [currentNumber, setCurrentNumber] = useState(3);
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('');
  const [showNext, setShowNext] = useState(false);
  const [apples, setApples] = useState([]);
  const inputRef = useRef(null);
  const maxNumber = 10;
  const soundRef = useRef(null);
  const wrongSoundRef = useRef(null);

  useEffect(() => {
    soundRef.current = new Audio('https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg');
    wrongSoundRef.current = new Audio('https://actions.google.com/sounds/v1/cartoon/cartoon_boing.ogg');
    generateQuestion(currentNumber);
  }, []);

  const generateQuestion = (num) => {
    setApples(Array(num).fill(false));
    setAnswer('');
    setFeedback('');
    setFeedbackColor('');
    setShowNext(false);
    setTimeout(() => inputRef.current?.focus(), 100);
  };

  const handleCheck = () => {
    const userAnswer = parseInt(answer);
    if (isNaN(userAnswer)) {
      setFeedback('Please enter a number!');
      setFeedbackColor('red');
      wrongSoundRef.current.play();
      return;
    }

    const correct = currentNumber * 2;
    if (userAnswer === correct) {
      setFeedback('🎉 Correct! Great job!');
      setFeedbackColor('green');
      setApples(Array(correct).fill(true));
      soundRef.current.play();
      setShowNext(true);
    } else {
      setFeedback('Try again! Hint: Double means add the same number again.');
      setFeedbackColor('red');
      wrongSoundRef.current.play();
    }
  };

  const handleNext = () => {
      if (currentNumber === maxNumber) {
    // This is the last question, trigger the update
    const responsedata = ConstructorEventUpdateSQLStatus();
    console.log("Event completed", responsedata);

    // Optionally restart from 1 if looping
    setCurrentNumber(1);
    generateQuestion(1);
  }
    const next = currentNumber < maxNumber ? currentNumber + 1 : 1;
    setCurrentNumber(next);
    generateQuestion(next);
  };

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive, sans-serif",
      background: '#fffbf0',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: '100vh',
      color: '#333',
    },
    header: {
      background: '#ff9f1c',
      width: '100%',
      padding: '1.5rem 0',
      textAlign: 'center',
      fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
      fontWeight: 'bold',
      color: 'white',
      boxShadow: '0 4px 10px #fca311',
    },
    main: {
      marginTop: '2rem',
      textAlign: 'center',
      width: '90vw',
      maxWidth: '600px',
      padding: '0 1rem',
    },
    question: {
      fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
      marginBottom: '1rem',
    },
    applesContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginBottom: '1.5rem',
      minHeight: '100px',
    },
    apple: (animate) => ({
      fontSize: 'clamp(2rem, 5vw, 2.5rem)',
      margin: '0.3rem',
      animation: animate ? 'pop 0.4s ease forwards' : 'none',
    }),
    input: {
      fontSize: '1.2rem',
      padding: '0.5rem',
      margin: '0 auto 1rem',
      width: 'min(250px, 80%)',
      borderRadius: '6px',
      border: '2px solid #ff9f1c',
      textAlign: 'center',
      outline: 'none',
    },
    button: (disabled) => ({
      fontSize: '1.2rem',
      marginLeft: '0.5rem',
      padding: '0.6rem 1.2rem',
      background: disabled ? '#ffc77d' : '#ff9f1c',
      border: 'none',
      borderRadius: '8px',
      color: 'white',
      cursor: disabled ? 'default' : 'pointer',
      boxShadow: '0 3px 8px #fca311',
      marginTop: '0.5rem',
    }),
    feedback: {
      marginTop: '1rem',
      fontWeight: 'bold',
      fontSize: '1.3rem',
      height: '30px',
      color: feedbackColor,
    },
    footer: {
      marginTop: 'auto',
      padding: '15px 10px',
      fontSize: '0.9rem',
      color: '#777',
    },
    keyframes: `@keyframes pop { 0% { transform: scale(1); } 50% { transform: scale(1.4); } 100% { transform: scale(1); } }`,
  };

  return (
    <div style={styles.body}>
      <style>{styles.keyframes}</style>
      <header style={styles.header}>Double the Apples! 🍎🍎</header>
      <main style={styles.main}>
        <div style={styles.question}>
          What is double {currentNumber}? Imagine a magic mirror that makes the apples appear again!
        </div>
        <div style={styles.applesContainer}>
          {apples.map((a, i) => (
            <div key={i} style={styles.apple(a)}>🍎</div>
          ))}
        </div>
        <div>
          <input
            type="number"
            ref={inputRef}
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            style={styles.input}
            placeholder="Your answer"
            disabled={showNext}
            onKeyDown={(e) => { if (e.key === 'Enter') handleCheck(); }}
          />
          <button
            style={styles.button(showNext)}
            onClick={handleCheck}
            disabled={showNext}
          >
            Check
          </button>
        </div>
        <div style={styles.feedback}>{feedback}</div>
        {showNext && (
          <button style={styles.button(false)} onClick={handleNext}>
            Next 🍎
          </button>
        )}
      </main>
    </div>
  );
};

export default DoubleTheApples;
